/**
 * Calculate date ranges for energy analysis
 */

export interface DateRange {
  startDate: string;
  endDate: string;
}

/**
 * Calculate the start and end dates for the last 8 weeks
 * Returns dates in ISO format (YYYY-MM-DDTHH:MM:SS+00:00)
 */
export const calculate8WeekRange = (): DateRange => {
  const endDate = new Date();
  const startDate = new Date(endDate);
  startDate.setDate(startDate.getDate() - 56); // 8 weeks = 56 days

  return {
    startDate: startDate.toISOString().replace('Z', '+00:00'),
    endDate: endDate.toISOString().replace('Z', '+00:00'),
  };
};

/**
 * Calculate the date range for the last 4 weeks (most recent)
 */
export const calculateLast4WeeksRange = (): DateRange => {
  const endDate = new Date();
  const startDate = new Date(endDate);
  startDate.setDate(startDate.getDate() - 28); // 4 weeks = 28 days

  return {
    startDate: startDate.toISOString().replace('Z', '+00:00'),
    endDate: endDate.toISOString().replace('Z', '+00:00'),
  };
};

/**
 * Calculate the date range for weeks 4-8 (older 4 weeks)
 */
export const calculateWeeks4To8Range = (): DateRange => {
  const endDate = new Date();
  endDate.setDate(endDate.getDate() - 28); // Start of the 4-8 week period

  const startDate = new Date(endDate);
  startDate.setDate(startDate.getDate() - 28); // 28 days earlier

  return {
    startDate: startDate.toISOString().replace('Z', '+00:00'),
    endDate: endDate.toISOString().replace('Z', '+00:00'),
  };
};

/**
 * Calculate trend percentage between two periods
 * Positive means increase, negative means decrease
 */
export const calculateTrendPercentage = (
  currentPeriodValue: number | null | undefined,
  previousPeriodValue: number | null | undefined,
): number | null => {
  if (
    currentPeriodValue === null ||
    currentPeriodValue === undefined ||
    previousPeriodValue === null ||
    previousPeriodValue === undefined ||
    previousPeriodValue === 0
  ) {
    return null;
  }

  return (
    ((currentPeriodValue - previousPeriodValue) / previousPeriodValue) * 100
  );
};
